// @flow
import React from 'react';

import IconBill from './icon/IconBill';
import styles from './Bill.scss';


type Props = {
  link: ?string,
}

const Bill = ({ link }: Props) => (link
  ? <a href={link} target="_blank" rel="noopener noreferrer">
    <IconBill className={styles.billIcon} />
  </a>
  : null
);

export default Bill;
